import { render, staticRenderFns } from "./TariffDetail.vue?vue&type=template&id=35acabba&"
import script from "./TariffDetail.vue?vue&type=script&lang=ts&"
export * from "./TariffDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports